module.exports = __webpack_public_path__ + "static/media/sjsulogo.96037b88.png";